import SectionLabel, { Sparkle } from './SectionLabel';

const cards = [
  {
    title: 'FOR INDEPENDENT ARTISTS',
    body: 'We are a 360° support system offering Music Production, Video Production, and Strategic Marketing.',
    variant: 'orange',
  },
  {
    title: 'FOR THE INDUSTRY',
    body: 'We are a trusted service partner for Major Labels and Production Houses, delivering high-end marketing campaigns, ad film scoring, and mixing services that meet global standards.',
    variant: 'dark',
  },
];

const EcosystemSection = () => {
  return (
    <section className="bg-[#0D0D0D] py-[64px] md:py-[90px] lg:py-[124px]">
      <div className="max-w-[1108px] mx-auto px-5 md:px-8 lg:px-0">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-[40px] md:gap-[56px] lg:gap-[96px]">
          {/* Left copy */}
          <div className="lg:pt-[75px] order-1">
            <SectionLabel align="left">WHAT WE DO</SectionLabel>
            <h2 className="mt-[16px] md:mt-[22px] text-white font-bold leading-[1.12] text-[30px] sm:text-[36px] md:text-[42px] lg:text-[54px]">
              A comprehensive
              <br className="hidden sm:block" /> music ecosystem
            </h2>
            <p className="mt-[20px] md:mt-[28px] text-white/60 text-[15px] md:text-[16px] lg:text-[18px] leading-[1.62] max-w-[500px]">
              Artistto is designed to professionalize creativity. We function as a bridge between raw
              talent and industry success, providing the infrastructure artists need to thrive.
            </p>
            <p className="mt-[20px] md:mt-[28px] text-white font-semibold text-[15px] md:text-[16px] lg:text-[18px]">
              We operate on two fronts:
            </p>
          </div>

          {/* Right cards */}
          <div className="order-2 flex flex-col gap-[16px] md:grid md:grid-cols-2 md:gap-[18px] lg:flex lg:flex-col">
            {cards.map((card) => (
              <div
                key={card.title}
                className={`rounded-[12px] p-[24px] md:p-[28px] ${
                  card.variant === 'orange'
                    ? 'bg-[#FF8000]'
                    : 'bg-[#141414] border border-white/10'
                }`}
              >
                <Sparkle className="w-[17px] h-[17px] text-white" />
                <h3 className="mt-[20px] md:mt-[26px] text-white font-bold uppercase text-[17px] md:text-[19px] lg:text-[23px] leading-[1.15]">
                  {card.title}
                </h3>
                <p
                  className={`mt-[10px] md:mt-[14px] text-[14px] md:text-[15px] lg:text-[16px] leading-[1.55] ${
                    card.variant === 'orange' ? 'text-white/90' : 'text-white/55'
                  }`}
                >
                  {card.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EcosystemSection;
